export * from './IdentityStepScanFaceIcon';
export * from './IdentityStepTakePictureIcon';
export * from './IdentityStepTypeIdIcon';
